import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import "../../styles/customers-styles.scss"
import { useFormik } from 'formik'
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-toastify';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    CUSTOMER_ADDED_SUCCESSFULLY,
    ERROR_WHILE_CREATING_CUSTOMER,
} from 'utlis/AppMessages/AppMessages'

import { cancelAdminUsersApi, getAdminGroups } from 'utlis/Apis/AdminUsers_API'
import { addCustomer, addCustomerAddress, getCustomerCountries, getCustomerGroups } from 'utlis/Apis/Customers_API'
import FormCustomersDetails from './Includes/FormCustomers__Details'
import FormCustomersAddress from './Includes/FormCustomersAddress'
import { addressFormValues, addressFormVS, formValidationSchema, infoFormValues } from './FormHelper'
import CreateCustomerTopBar from './Includes/CreateCustomerTopBar'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function CreateCustomer(props) {
    // props
    const { authState } = props

    const detailsSubmitRef = useRef(null)
    const addressSubmitRef = useRef(null)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)

    const [adminGroups, setAdminGroups] = useState([])
    const [customerGroups, setCustomerGroups] = useState([])
    const [countries, setCountries] = useState([])
    const [step, setStep] = useState(1)
    // const [direct, setDirect] = useState(false)
    const [userId, setId] = useState("")

    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        getCountries_()
        getCustomerGroups_()
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getAdminGroups(headers).then(res => {
            const adminGroupsData = res.data
            if (adminGroupsData.success) {
                setAdminGroups(adminGroupsData.data.data)
            }
            if (adminGroupsData.error) {
                console.log('Error occured while loading admin groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getAdminGroups `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        return () => {
            cancelAdminUsersApi()
        }

    }, [authState])

    const getCustomerGroups_ = () => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerGroups(headers).then(res => {
            const customerGroupData = res.data
            if (customerGroupData.success) {
                setCustomerGroups(customerGroupData.data)
            }
            if (customerGroupData.error) {
                console.log('Error occured while loading customer groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomerGroup `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }
    const getCountries_ = () => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerCountries(headers).then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const onCreateFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setCreateButtonLoading(true)
            if (userId) {
                addAddress(values)
            } else {
                const headers = {
                    "Authorization": `Bearer ${authState.commonToken}`,
                    "Api-Token": authState.apiToken,
                    "Access-Token": "",
                    // "Store-Id": authState.storeId,
                }
                addCustomer(headers, values).then(res => {
                    setGlobalLoading(false)
                    const addingCustomer = res.data
                    if (addingCustomer.success) {
                        setId(addingCustomer.user_id)
                        onSuccess(res)
                    } else if (addingCustomer.error) {
                        onError(addingCustomer)
                    }
                }).catch(err => {
                    console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
                    onCatch()
                })
            }
        }
    }

    const addAddress = (values) => {
        const address = {
            user_id: userId,
            address_type: values.address_type || "",
            shipping_first_name: values.address_shipping_first_name || "",
            shipping_middle_name: values.address_shipping_middle_name || "",
            shipping_last_name: values.address_shipping_last_name || "",
            shipping_company_name: values.address_shipping_company_name || "",
            shipping_address: values.address_shipping_address || "",
            shipping_address1: values.address_shipping_address1 || "",
            shipping_city: values.address_shipping_city || "",
            shipping_country: values.address_shipping_country || "",
            shipping_state: values.address_shipping_state || "",
            shipping_zipcode: values.address_shipping_zipcode || "",
            shipping_phone: values.address_shipping_phone || "",
            shipping_mobile: values.address_shipping_mobile || "",
            shipping_fax: values.address_shipping_fax || "",
            is_default: 1
        }
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        addCustomerAddress(headers, address).then(res => {
            if (res.data.error) {
                onError(res.data)
            }
            if (res.data.success) {
                onSuccess(res)
            }
        }).catch(err => {
            onCatch(err)
        })

    }
    const onError = (res) => {
        console.log(ERROR_WHILE_CREATING_CUSTOMER, res)
        setCreateButtonLoading(false)
        toast.dismiss();
        let error = ""
        if (typeof res.message === 'string' || res.message instanceof String) {
            error = res.message
        } else {
            Object.keys(res.message).forEach(function (key) {
                error = error + res.message[key] + " "
            });
        }

        toast.error(error || ERROR_WHILE_CREATING_CUSTOMER, {
            autoClose: 3000,
        })
    }
    const onCatch = () => {
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setGlobalLoading(false)
                setCreateButtonLoading(false)
            }
        })

    }
    const onSuccess = () => {
        setCreateButtonLoading(false)
        window.scrollTo(0, 0)
        toast.dismiss();
        props.history.push(storeUrl + '/my-sales/customers/', {
            shouldReload: true
        })
        toast.success(CUSTOMER_ADDED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => {
                // // if ((step === 1 && direct) || step === 2) {
                // //     setId("")
                // //     props.history.push(storeUrl + '/my-sales/customers/', {
                // //         shouldReload: true
                // //     })
                // // } else if (step === 1) {
                // //     setStep(2)
                // // }
                if (step === 1) {
                    setId("")

                } else {
                    setStep(2)
                }
            }
        })
    }


    const detailsFormik = useFormik({
        initialValues: infoFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true,
    })
    const addressFormik = useFormik({
        initialValues: addressFormValues,
        validationSchema: addressFormVS,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true,
    })
    const handleFormSubmission = (ev, direct) => {
        ev.preventDefault()
        // setDirect(direct)
        if (userId) {
            addressSubmitRef.current.click()
        } else {
            detailsSubmitRef.current.click()
        }
    }

    const SideBarItem = ({ name, n }) => {
        return (<div className={`shrunk  ${step === n ? "border-bottom st-border-light" : "border-bottom st-border-light"}`} onClick={() => { setStep(n) }}>
            <div className={`customer-sidebar-item ${step === n ? "customer-active-sidebar-item" : ""}`} >
                <div className="top-sec d-flex align-items-center" >
                    {step === n ? <FeatherIcon
                        icon="disc"
                        size="8"
                        className="icon me-2" /> :
                        <FeatherIcon
                            icon="circle"
                            size="8"
                            className="icon me-2" />
                    }
                    <span>{name}</span>
                </div>
            </div>
        </div>)
    }
    const sideBarItems = ["Account Information"] //["Account Information", "Address"]

    return (
        <section id="app-customers__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-customers__create-details ">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Create Customer</p>
                        <p className="app-desc">
                            Create a customer who will have access to different parts of your store.
                            you can assign different customers different roles.
                        </p>
                    </div>
                    <div className="app-card customer">
                        <div className="app-card-content bg-white border st-default-rounded-block mb-3 pad-12-T pad-12-B">
                            <div className="app-content-container categories-wrapper">
                                <CreateCustomerTopBar
                                    handleFormSubmission={handleFormSubmission}
                                    userId={userId}
                                    step={step}
                                    formik={step === 1 ? detailsFormik : addressFormik}
                                    setStep={(s) => { setStep(s) }}
                                    loading={createButtonLoading}
                                />
                            </div>
                            <div className="categories-wrapper-inner d-flex flex-wrap">
                                <div className="customer-sidebar">
                                    <div className="inner">
                                        {sideBarItems.map((e, index) => <SideBarItem name={e} n={index + 1} key={index} />)}
                                    </div>
                                </div>
                                <div className="category-data-view media-body position-relative bg-white  pad-20-L pad-20-R">
                                    {step === 1 ? <Col xs={12} md={12} lg={9} className="px-0">
                                        <div className="app-header-wrapper heading-sm pad-15">
                                            <p className="app-heading text-uppercase st-text-light st-text-light st-fs-16 st-fw-700">Account Information</p>
                                        </div>
                                        <div className="pad-12-L pad-12-B pad-12-R">
                                            <div className="app-card customer-form">
                                                <div className="app-card-content border st-default-rounded-block mb-3 pad-12-T pad-12-B pad-12-R pad-12-L">
                                                    <div className="app-card mb-3 mb-lg-4">
                                                        <div className="app-card-content  pad-20-LR pad-20-T">
                                                            <Col xs={12} md={9} lg={11} className="px-0">
                                                                <form
                                                                    onSubmit={detailsFormik.handleSubmit}
                                                                    noValidate
                                                                    autoComplete="off">
                                                                    <FormCustomersDetails
                                                                        formik={detailsFormik}
                                                                        adminGroups={adminGroups}
                                                                        customerGroups={customerGroups}
                                                                    />
                                                                    <button
                                                                        ref={detailsSubmitRef}
                                                                        type="submit"
                                                                        id="customerAddress"
                                                                        className="d-none">submit</button>
                                                                </form>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col> : ""
                                    }
                                    {step === 2 ? <Col xs={12} md={12} lg={userId ? 12 : 9} className="px-0">
                                        <div className="app-header-wrapper heading-sm pad-15">
                                            <p className="app-heading text-uppercase st-text-light st-text-light st-fs-16 st-fw-700">Address</p>
                                        </div>
                                        <div className="pad-12-L pad-12-R pad-12-B">
                                            {!userId ? <div className="text-center text-danger">Create Customer First</div> :
                                                <div className="app-card customer-form">
                                                    <div className="app-card-content border st-default-rounded-block mb-3 pad-12-T pad-12-B pad-12-R pad-12-L">
                                                        <div className="app-card mb-3 mb-lg-4">
                                                            <div className="app-card-content  pad-20-LR pad-20-T">
                                                                <Col xs={12} md={9} lg={11} className="px-0">
                                                                    <form
                                                                        onSubmit={addressFormik.handleSubmit}
                                                                        noValidate
                                                                        autoComplete="off">
                                                                        <FormCustomersAddress
                                                                            authState={authState}
                                                                            detailsFormik={detailsFormik}
                                                                            formik={addressFormik}
                                                                            countries={countries}
                                                                            userId={userId}
                                                                        />
                                                                        <button
                                                                            ref={addressSubmitRef}
                                                                            className="d-none"
                                                                            id="customerAddress"
                                                                            type="submit">submit</button>
                                                                    </form>
                                                                </Col>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                        </div>
                                    </Col> : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateCustomer)